<script setup>
import {
  ref,
  reactive,
  onMounted,
} from 'vue'
import { KkIcon } from '../../../base'

const video = ref(null)
const props = defineProps({
  movie: { type: Object, required: true },
})
const state = reactive({
  isVideoPause: true,
  minutes: 0,
  seconds: 0
})

const clickVideo = () => {
  if(video.value.paused) {
    video.value.play()
  } else {
    video.value.pause()
  }
}

onMounted(() => {
  if (!props.movie) return

  video.value.onpause = () => {
    state.isVideoPause = video.value.paused
  }
  video.value.onplay = () => {
    state.isVideoPause = video.value.paused
  }
  video.value.oncanplay = () => {
    const maxTime = Math.floor(video.value.duration)
    state.minutes = ('00' + Math.floor(maxTime / 60)).slice(-2)
    state.seconds = ('00' + Math.floor(maxTime % 60)).slice(-2)
  }
  video.value.ontimeupdate = () => {
    const maxTime = Math.floor(video.value.duration)
    const nowTime = maxTime - Math.floor(video.value.currentTime)
    state.minutes = ('00' + Math.floor(nowTime / 60)).slice(-2)
    state.seconds = ('00' + Math.floor(nowTime % 60)).slice(-2)
  }
})
</script>
<template>
  <div class="preview__movieContainer" @click="clickVideo">
    <video ref="video" :src="props.movie.url" muted />
    <div v-if="state.isVideoPause"><KkIcon name="videoPlay" class="preview__moviePlay" /></div>
    <div class="preview__movieTime">{{ `${state.minutes}:${state.seconds}` }}</div>
  </div>
</template>

<style lang="scss" scoped>
.preview {
  &__movieContainer {
    display: flex;
    position: relative;
    video {
      width: 100%;
      border-radius: 4px;
      background-color: #F5F6F9;
    }
  }
  &__moviePlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    width: 36px;
    height: 36px;
  }
  &__movieTime {
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 10px;
    padding: 3px;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
  }
}
</style>
